export default __webpack_public_path__ + "static/media/bug.69c6fcb1.svg";